<template>
  <el-form-item :label="`${hideLabel ? '' : label}`" style="width: 100%">
    <div class="filter-select">
      <multiselect
        v-if="is_filter && searchable"
        ref="multiselect"
        :value="value"
        :disabled="disabled"
        @close="blur"
        @input="input"
        :placeholder="label"
        :searchable="true"
        selectLabel=""
        :close-on-select="!multiple"
        :preserve-search="false"
        deselectLabel=""
        tag-placeholder="Значение не найдено"
        selectedLabel="Выбрано"
        noOptions="Не найдено"
        noResult="Не найдено"
        label="label"
        track-by="value"
        :multiple="multiple"
        :taggable="multiple"
        :options="options"
      >
        <div slot="noResult" slot-scope="{ search }">
          <el-button size="mini" @click="addNew(search)" v-if="addNewEnable">Добавить ед.</el-button>
          <span v-else>Не найдено</span>
        </div>
      </multiselect>
      <multiselect
        v-else
        :disabled="disabled"
        ref="multiselect"
        :close-on-select="!multiple"
        :value="value"
        tag-placeholder="Значение не найдено"
        @input="input"
        :placeholder="label"
        :searchable="false"
        :taggable="multiple"
        selectLabel=""
        :multiple="multiple"
        deselectLabel=""
        selectedLabel="Выбрано"
        noOptions="Не найдено"
        noResult="Не найдено"
        :label="label_by"
        :track-by="track_by"
        :options="options"
      >
        <div slot="noResult" slot-scope="{ search }">
          <el-button size="mini" @click="addNew(search)" v-if="addNewEnable">Добавить ед.</el-button>
          <span v-else>Не найдено</span>
        </div>
      </multiselect>
      <div v-if="m_v" @click="toggleFilter" class="search-btn">
        <i class="fa fa-search"></i>
      </div>
    </div>
  </el-form-item>
</template>

<script>
import Multiselect from 'vue-multiselect';
import MobileDetect from 'mobile-detect';

export default {
    name: 'FilterSelect',
    props: {
        options: Array,
        value: [Object, String],
        addNewEnable: Boolean,
        label: String,
        track_by: {
            type: String,
            default: 'value',
        },
        hideLabel: Boolean,
        label_by: {
            type: String,
            default: 'label',
        },
        disabled: Boolean,
        multiple: Boolean,
        single: Boolean,
        searchable: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        Multiselect,
    },
    data() {
        const md = new MobileDetect(window.navigator.userAgent);
        return {
            isOpen: false,
            is_mobile: md.mobile() !== null,
            is_filter: md.mobile() === null,
            m_v: md.mobile(),
        };
    },
    methods: {
        input(v) {
            this.$emit('input', v);
            if (this.single) {
                this.$refs.multiselect.toggle();
            }
        },
        addNew(d) {
            this.$emit('addNew', d);
            this.$refs.multiselect.toggle();
        },
        blur() {
            if (this.m_v) {
                this.is_filter = false;
            }
        },
        toggleFilter() {
            this.is_filter = !this.is_filter;
            this.$nextTick(() => {
                this.$refs.multiselect.$el.focus();
            });
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
> > > .multiselect__tag, > > > .multiselect__option--highlight, > > > .multiselect__option--highlight:after {
  background: #3a8ee6;
}

> > > .multiselect__tag-icon:focus, > > > .multiselect__tag-icon:hover {
  background: #3a8ee6 !important;
}

> > > .multiselect__tag-icon:after {
  color: #1c5591 !important;
}

> > > .el-form-item__content {
  line-height: normal !important;
}

.filter-select {
  display: flex;
}

.search-btn {
  border: 1px solid #e8e8e8;
  background: #fff;
  border-radius: 5px;
  width: 46px;
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

[data-select="Значение не найдено"] {
  span {
    display: none !important;
  }
}

.filter-select {
  width: 100%;

  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/FilterSelect.vue